import { useEffect } from "react";

import { useConcursoTikTok } from "../../../../hooks/useConcursoTikTok2025"
import DateStepView from "./DateStepView";

const DateStepsView = () => {
    const { etapas, getEtapas } = useConcursoTikTok();

    useEffect(() => {
        getEtapas(2026)
    }, [])

    return (
        <div className="container-fluid section-home" id="etapas-fechas">
            <div className="row justify-content-center">
                <div className="col-12 anchor-section">
                </div>
                <div className="col-md-8 inner-sections">
                    <div className="title-tiktok-info">
                        <h2>Etapas y fechas</h2>
                    </div>
                    <div className="container-inner-info p-4">
                        <div className="phases-section-grid">
                            {
                                etapas.map(({ etapa, fecha }, i) => (
                                    <DateStepView items={[etapa, fecha]}/>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DateStepsView
